import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initNotifications } from "./notifications";

try {
  initNotifications();
} catch (e) {}

// ✅ PWA Install Prompt — add here
let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.__deferredPrompt = e; // ✅ make it accessible from anywhere in the app
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  window.__deferredPrompt = null;
});

// ✅ end PWA block

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js")
    .then(() => console.log("SW registered"))
    .catch(err => console.log("SW error", err));
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
